/* eslint-disable no-tabs */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import { setIsBookDemoModalShowing } from '../../ducks/sportsScienceActions';
import BookDemoModal from './BookDemoModal';

const BookDemoModalOverlay = styled('div')`
  height: 100vh;
  width: 100vw;
  position: absolute;
  background-color: rgba(216, 216, 216, 0.8);
  z-index: 1002;
  pointer-events: ${(props) => (props.isActive ? 'auto' : 'none')};
  transition: opacity 0.3s ease;
  opacity: ${(props) => (props.isActive ? 0.5 : 0)};
`;

const BookDemoModalContainer = () => {
  const dispatch = useDispatch();
  const isBookDemoModalShowing = useSelector(
    (state) => state.sportsScience.data.isBookDemoModalShowing,
  );

  return (
    <>
      <BookDemoModal />
      <BookDemoModalOverlay
        isActive={isBookDemoModalShowing}
        onClick={
          () => dispatch(setIsBookDemoModalShowing(false))
          }
      />
    </>
  );
};

BookDemoModalContainer.propTypes = { };

export default BookDemoModalContainer;
